import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Leon_Renters/subs.vtt';
import poster from '@/static/assets/reviews/Leon_Renters/video.jpg';

export const Leon: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Renters, ReviewProduct.All],
  reviewerName: 'Leon',
  videoUrl: `${ASSETS_URL}/renters/Leon_Renters_Webm.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
